import { MasterCampaignPlanResourceType } from 'api/entities/MasterCampaignPlan'
import config from 'app/config'

export const downloadPdf = (blob: Blob, fileName: string) => {
  const blobUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = blobUrl
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(blobUrl)
}

export const fetchMasterCampaignPlanPdfBlob = async (id: string, masterCampaignPlanResourceType: MasterCampaignPlanResourceType): Promise<Blob> => {
  const response = await fetch(`${config.api.BASEURL}masterCampaignPlans/${id}/pdf?type=${masterCampaignPlanResourceType}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })

  if (!response.ok) {
    throw new Error('Failed to download client plan PDF')
  }

  return response.blob()
}
